import React from 'react';
import Heading from '@atlaskit/heading';
import { Text, Stack, Flex } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

export const UnlockedAdminContent = () => {
	const { formatMessage } = useIntl();

	return (
		<Flex rowGap="space.200" direction="column">
			<Heading level="h800">{formatMessage(messages.titleNonFinal)}</Heading>
			<Stack space="space.100">
				<Text>{formatMessage(messages.description1NonFinal)}</Text>
				<Text>{formatMessage(messages.description2NonFinal)}</Text>
			</Stack>
		</Flex>
	);
};
